import axios from 'axios'
import config from './config';

//对接专用
function request(api_type, url, method, data, callback) {
    url = config.openApi +  url;

    return axios({
        http_timeout: config.httpTimeout,
        url: url,
        method: method,
        data: data,//btoa(),//btoa base64
        headers: {
            'content-type': 'application/json',
            // 'content-type': 'application/x-www-form-urlencoded'
        }
    }).then(function(res) {
        if(typeof res.data == 'string'){
            const resStr = res.data
            res.data = JSON.parse(resStr.substring(resStr.indexOf('{"s":'),resStr.length));
        }

        success(res,callback);
        return res;
    }).catch(err =>{
        error(err,callback);
        return err;
    });
}
//成功回调
function success(res,callback) {
    if (typeof (callback) == "function") {
        res = res.data;
        console.log(JSON.stringify(res));

        var errno, errmsg, data;
        errno = res.s; errmsg = res.m;data = res.d;

        var error = {
            errno: errno,
            errmsg: errmsg
        };
        return callback(errno == "0", data, error);
    }
}
//失败回调
function error(res,callback) {
    if (typeof (callback) == "function") {

        var resmsg = res.toString();
        if(resmsg === "repeated_requests"){
            console.log("重复请求被终断");
        }
        else{
            var errmsg = resmsg == "http_timeout"? config.i18n.tc('http_overtime') : config.i18n.tc('server_error');
            var error = {
                errno: "-1",
                errmsg: errmsg
            };
            return callback(false, null, error);
        }
    }
}
//发送post
export function sendPost_open(url, data, callback) {
    return request('open', url, "post", data, callback);
}

export default {
    sendPost_open
}



// WEBPACK FOOTER //
// ./src/utils/request_api.js